// src/services/sessionStore.js
// Состояние браузерной сессии, общее для всех вкладок одного origin:
// access-токен и флажок сессии в localStorage, события между вкладками через BroadcastChannel.
import jwt_decode from 'jwt-decode';

const TOKEN_KEY = 'token';
// Признак, что у браузера есть refresh-cookie: без него refresh при старте не делаем
const SESSION_FLAG_KEY = 'pr_has_session';
const CHANNEL_NAME = 'pr-auth';

export const AUTH_EVENT_REFRESHED = 'refreshed';
export const AUTH_EVENT_LOGOUT = 'logout';

const channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel(CHANNEL_NAME) : null;

export function getAccessToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function storeAccessToken(accessToken) {
  localStorage.setItem(TOKEN_KEY, accessToken);
  localStorage.setItem(SESSION_FLAG_KEY, '1');
  window.dispatchEvent(new Event('auth-token-updated'));
  return accessToken;
}

export function clearBrowserSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(SESSION_FLAG_KEY);
}

// Есть ли смысл пробовать refresh: флажок или access-токен (у вошедших до появления флажка его нет)
export function hasSessionHint() {
  return Boolean(localStorage.getItem(SESSION_FLAG_KEY) || getAccessToken());
}

function isExpired(token) {
  try {
    return jwt_decode(token).exp < Date.now() / 1000;
  } catch {
    return true;
  }
}

// Токен, который другая вкладка положила вместо `previous` и который ещё действует
export function getTokenRefreshedElsewhere(previous) {
  const token = getAccessToken();
  if (token && token !== previous && !isExpired(token)) return token;
  return null;
}

export function broadcastAuth(type) {
  try {
    channel?.postMessage({ type });
  } catch {
    // канал закрыт — другие вкладки узнают при следующем запросе
  }
}

export function subscribeAuthBroadcast(handler) {
  if (!channel) return () => {};
  const listener = (event) => handler(event.data?.type);
  channel.addEventListener('message', listener);
  return () => channel.removeEventListener('message', listener);
}
